var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-popup monitor-graph", attrs: { id: "skew-chart" } },
    [
      Object.keys(_vm.skew_options)
        ? _c("v-card", { staticClass: "base-popup__wrapper" }, [
            _c("div", { attrs: { id: "base-popup__capture_range" } }, [
              _c("div", { staticClass: "base-popup__content" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "base-popup__content-detail d-flex align-center justify-space-between"
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.skew_options.title))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.latlng_text))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { id: "tsgraph-download", icon: "" },
                            on: { click: _vm.save_png }
                          },
                          [
                            _c("v-icon", { attrs: { color: "black" } }, [
                              _vm._v(
                                "\n                                icon-file-download\n                            "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { color: "black", icon: "" },
                            on: { click: _vm.close_dialog }
                          },
                          [
                            _c("v-icon", { attrs: { color: "black" } }, [
                              _vm._v(
                                "\n                                mdi-close\n                            "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "base-popup__content-graph" }, [
                  _c("div", { staticClass: "svg_container" }, [_c("svg")])
                ])
              ])
            ])
          ])
        : _vm.error_text
          ? _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    staticClass: "error__box",
                    attrs: { value: true, type: "info", color: "#ee3934" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.error_text) +
                        "\n            "
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "error__close-btn",
                        attrs: { color: "white", icon: "" },
                        on: { click: _vm.close_dialog }
                      },
                      [_c("v-icon", [_vm._v("mdi-close")])],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c("LoadingHint", {
              attrs: { text: _vm.$t("__chart_common.loading_text") }
            })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }